const Linkedin = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M21.959 13.7184V21.0974H17.681V14.2124C17.681 12.4824 17.062 11.3024 15.514 11.3024C14.332 11.3024 13.628 12.0984 13.319 12.8674C13.206 13.1424 13.177 13.5254 13.177 13.9104V21.0974H8.897C8.897 21.0974 8.955 9.43739 8.897 8.22839H13.177V10.0524L13.149 10.0944H13.177V10.0524C13.745 9.17739 14.76 7.92639 17.033 7.92639C19.848 7.92639 21.959 9.76639 21.959 13.7184ZM4.421 2.02539C2.958 2.02539 2 2.98539 2 4.24839C2 5.48339 2.93 6.47239 4.365 6.47239H4.393C5.886 6.47239 6.813 5.48339 6.813 4.24839C6.787 2.98539 5.887 2.02539 4.422 2.02539H4.421ZM2.254 21.0974H6.532V8.22839H2.254V21.0974Z"
      fill="currentColor"
    />
  </svg>
);

export default Linkedin;
